import React from "react";

export default function Logo({ variant = "dark", className = "h-10" }) {
  const src = variant === "light" ? "/km-logo-light-v4.png" : "/km-logo-v4.png";
  return (
    <img
      src={src}
      alt="Kate Mercer Books"
      className={`${className} w-auto select-none img-crisp`}
      draggable="false"
      decoding="async"
    />
  );
}
